export const maintenanceStandardAssetsFiltersActions = {
    SET_CURRENT_COST_CENTER: 'MAINTENANCE_STANDARD_ASSETS/SET_CURRENT_COST_CENTER',
    SET_IS_SEARCH_BY_CHILD_ASSET: 'MAINTENANCE_STANDARD_ASSETS/SET_IS_SEARCH_BY_CHILD_ASSET',
    SET_SEARCH_VALUE: 'MAINTENANCE_STANDARD_ASSETS/SET_SEARCH_VALUE',
    SET_IS_LOADING_DATA: 'MAINTENANCE_STANDARD_ASSETS/SET_IS_LOADING_DATA',
    SET_PAGINATOR_PAGE: 'MAINTENANCE_STANDARD_ASSETS/SET_PAGINATOR_PAGE',
    RESET_ASSETS_FILTERS: 'MAINTENANCE_STANDARD_ASSETS/RESET_ASSETS_FILTERS',
};

export const setCurrentCostCenter = payload => {
    return {
        type: maintenanceStandardAssetsFiltersActions.SET_CURRENT_COST_CENTER,
        payload,
    };
};

export const setIsSearchByChildAsset = payload => {
    return {
        type: maintenanceStandardAssetsFiltersActions.SET_IS_SEARCH_BY_CHILD_ASSET,
        payload,
    };
};

export const setSearchValue = payload => {
    return {
        type: maintenanceStandardAssetsFiltersActions.SET_SEARCH_VALUE,
        payload,
    };
};

export const setIsLoadingData = payload => {
    return {
        type: maintenanceStandardAssetsFiltersActions.SET_IS_LOADING_DATA,
        payload,
    };
};

export const setPaginatorPage = payload => {
    return {
        type: maintenanceStandardAssetsFiltersActions.SET_PAGINATOR_PAGE,
        payload,
    };
};

export const resetAssetsFilters = () => {
    return {
        type: maintenanceStandardAssetsFiltersActions.RESET_ASSETS_FILTERS,
    };
};
